import type { Move } from './ChessRules';
export const audioEvents = [
  'move',
  'capture',
  'check',
  'castle',
  'promotion',
  'incorrect',
  'correct-step',
  'solved',
  'checkmate',
] as const;
export type AudioEvent = (typeof audioEvents)[number];
export function moveSound(move: Move): AudioEvent {
  return move.san.endsWith('#')
    ? 'checkmate'
    : move.promotion
      ? 'promotion'
      : move.isKingsideCastle() || move.isQueensideCastle()
        ? 'castle'
        : move.san.includes('+')
          ? 'check'
          : move.captured
            ? 'capture'
            : 'move';
}
